import { component as defineComponent } from 'flightjs';
import '@99designs/common/jquery-plugins/modal';

var pollEntryModal = function() {
    this.attributes({
        modalTrigger: '[data-modal-name]',
        entryImage: '[data-poll-entry-image]',
        modalImage: '[data-poll-entry-modal-image]',
        closeButton: '[data-modal-close]',
    });

    this.after('initialize', function() {
        this.on('click', {
            entryImage: this.showModal,
        });
        this.on('click', {
            closeButton: this.closeModal,
        });
    });

    this.showModal = function(e, data) {
        e.preventDefault();

        const entryOriginalImage = '[data-poll-entry-image-original]';
        const modalImageSrc = $(data.el)
            .find(entryOriginalImage)
            .attr('src');
        this.select('modalImage').attr('src', modalImageSrc);
        $('.classic-modal__inner').addClass('classic-modal__inner--extra-wide-content');

        if (this.select('modalTrigger').data('modal')) {
            this.select('modalTrigger')
                .data('modal')
                .show();
            $('.classic-modal__inner', this.select('modalTrigger').data('modal').$elem).scrollTop(
                0
            ); // patch Asimov modal
        }
    };

    this.closeModal = function() {
        this.select('modalImage').removeAttr('src');
    };
};

export default defineComponent(pollEntryModal);



// WEBPACK FOOTER //
// ./src/web/js/polls/modules/polls-entry-modal.js